var validProps = ['veltIf', 'veltClass', 'className'];
export var transformWireframeProps = function (props) {
    try {
        var transformedProps_1 = {};
        Object.entries(props).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key === 'children' || key === 'ref' || !validProps.includes(key)) {
                transformedProps_1[key] = value;
                return;
            }
            if (key === 'className') {
                transformedProps_1['class'] = value;
                return;
            }
            // Convert camelCase to dash-case
            var dashKey = key.replace(/[A-Z]/g, function (letter) { return "-".concat(letter.toLowerCase()); });
            transformedProps_1[dashKey] = value;
            // // Handle boolean values - only convert if explicitly true/false
            // if (typeof value === 'boolean') {
            //     transformedProps[dashKey] = [true, false].includes(value) ? (value ? 'true' : 'false') : undefined;
            // } else {
            //     transformedProps[dashKey] = value;
            // }
        });
        return transformedProps_1;
    }
    catch (error) {
        return props;
    }
};
